import { createContext, useContext, useState, ReactNode } from "react";
import Popup from "../components/Popup";

type PopupContextType = {
    openPopup: () => void;
    closePopup: () => void;
};

const PopupContext = createContext<PopupContextType | undefined>(undefined);

export function usePopup() {
    const context = useContext(PopupContext);
    if (!context) {
        throw new Error("usePopup must be used within a PopupProvider");
    }
    return context;
}

export function PopupProvider({ children }: { children: ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);

    const openPopup = () => setIsOpen(true);
    const closePopup = () => setIsOpen(false);

    return (
        <PopupContext.Provider value={{ openPopup, closePopup }}>
            {children}
            {isOpen && <Popup onClose={closePopup} />}
        </PopupContext.Provider>
    );
}
